// packages/web/src/api/invites/mutations.ts
import { useMutation } from "@tanstack/react-query";
import { invitesSetPassword, invitesMicrosoftStart } from "../generated/sdk.gen.ts";
import type { InvitesSetPasswordData } from "../generated/types.gen.ts";

type SetPasswordBody = NonNullable<InvitesSetPasswordData["body"]>;

export function useSetPassword() {
  return useMutation({
    mutationFn: async (vars: { token: string; body: SetPasswordBody }) => {
      const { data, error } = await invitesSetPassword({
        path: { token: vars.token },
        body: vars.body,
      });
      if (error) throw error;
      if (!data) throw new Error("No response data");
      return data;
    },
  });
}

export function useStartMicrosoft() {
  return useMutation({
    mutationFn: async (vars: { token: string }) => {
      const { data, error } = await invitesMicrosoftStart({ path: { token: vars.token } });
      if (error) throw error;
      if (!data) throw new Error("No response data");
      return data;
    },
  });
}
